let entity = "box"
export const GET_ALL =  `${process.env.REACT_APP_URL}${entity}`
export const GET =  `${process.env.REACT_APP_URL}${entity}/`
export const GET_BY_USER =  `${process.env.REACT_APP_URL}${entity}/byuser/`
export const REMOVE =  `${process.env.REACT_APP_URL}${entity}/`
export const POST =  `${process.env.REACT_APP_URL}${entity}/`
export const PUT =  `${process.env.REACT_APP_URL}${entity}/`